import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/layouts/default.vue").then(m => m.default || m))
}